import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ACCOUNT_SUSPENDED_DATA_VALUE_KEY } from "@constants/strings";
import { actions as authActions } from "@reducers/authReducer";
import analytics from "@services/analytics";
import { TICKET_RAISED_CLICK } from "@constants/analyticsEvents";

const SuspensionHOC = (Component) => {
  return (props) => {
    const dispatch = useDispatch();
    const [navigationPayload, setNavigationPayload] = useState(null);

    const {
      auth: {
        user: { is_suspended = false, has_raised_ticket = false, leader_state },
        showSuspensionModal,
        fetchMeCompleted,
      },
      support: { supportConfig },
    } = useSelector(({ auth, support }) => {
      return { auth, support };
    });

    const { children = [] } = supportConfig || {};

    useEffect(() => {
      if (Array.isArray(children) && children.length) {
        children.forEach((subChild) => {
          const data = subChild?.data?.find(
            (list) => list.dataValue === ACCOUNT_SUSPENDED_DATA_VALUE_KEY,
          );
          setNavigationPayload(data);
        });
      }
    }, [children.length]);

    const onClickRaiseSupportTicket = () => {
      const NavigationService = require("@utils/NavigationService").default;
      dispatch(authActions.showSuspensionModal(false));
      analytics.trackEvent(TICKET_RAISED_CLICK);
      NavigationService.navigate("RaiseTicket", {
        isLeaderSuspended: true,
      });
    };
    const viewProps = {
      ...props,
      is_suspended: is_suspended || leader_state === "LEADER_SUSPENDED",
      showSuspensionModal,
      supportConfig,
      navigationPayload,
      onClickRaiseSupportTicket,
      fetchMeCompleted,
    };
    return <Component {...viewProps} />;
  };
};

export default SuspensionHOC;
